// Root getters
export default {
  countPlusOne: state => {
    return state.count + 1
  },

  isLogged: state => {
    return state.isLogged === 1
  },

  getRefreshToken: state => {
    return state.auth.refreshToken
  },

  getAccessToken: state => {
    return state.auth.accessToken
  },

  layout: state => {
    return state.layout
  },

  user: state => {
    return state.user
  },

  beamsUser: state => {
    return state.beamsUser
  },

  notification: state => {
    return state.notification
  },

  version: state => {
    return state.version
  }
}
